import { useState, useEffect } from "react";
import { Tabs, Tab, Divider } from "@mui/material";
import styles from "./admin.css";
import CollectStatus from "../admin_tabs/collectStatus/collectStatus";
import PayoutStatus from "../admin_tabs/payoutStatus/payoutStatus";
import CollectToPayout from "../admin_tabs/collectToPayout/collectToPayout";
import Merchants from "../admin_tabs/merchants/merchants";
import { getUserProfile } from "../../../../helpers/profile_helper";

const Admin = () => {
  const [tabValue, setTabValue] = useState(0);
  const [userProfile, setUserProfile] = useState("")
  const [adminPermissions, setAdminPermissions] = useState([])
  const tabs = [
    {
      label: "Collect status",
      component: <CollectStatus />,
      show: process.env.REACT_APP_SHOW_COLLECT_STATUS === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Payout status",
      component: <PayoutStatus />,
      show: process.env.REACT_APP_SHOW_PAYOUT_STATUS === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Enable/disable merchants",
      component: <Merchants />,
      show: process.env.REACT_APP_SHOW_ENABLE_OR_DISABLE_MERCHANTS === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Collect to payout account",
      component: <CollectToPayout />,
      show: process.env.REACT_APP_SHOW_COLLECT_TO_PAYOUT_ACCOUNT === "true" && adminPermissions.includes('WIDTHDRAW_MASTER'),
    },
    {
      label: "Collect to pool", 
      component: <div>Collect to Pool</div>,
      show: process.env.REACT_APP_SHOW_COLLECT_TO_POOL === "true" && adminPermissions.includes('WIDTHDRAW_MASTER'),
    },
    {
      label: "Pool to payout",
      component: <div>Pool to Payout</div>,
      show: process.env.REACT_APP_SHOW_POOL_TO_PAYOUT === "true" && adminPermissions.includes('LOAD_PAYOUT_MASTER'),
    },
    {
      label: "Set collect fees" ,
      component: <div>Set Collect Fees</div>,
      show: process.env.REACT_APP_SET_COLLECT_FEES === "true"&& adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Set payout fees",
      component: <div>Set Payout Fees</div>,
      show: process.env.REACT_APP_SET_PAYOUT_FEES === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Transfer",
      component: <div>Transfer</div>,
      show: process.env.REACT_APP_SET_TRANSFER === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
    {
      label: "Add View Users",
      component: <div>Add View Users</div>,
      show: process.env.REACT_APP_ADD_VIEW_USER === "true" && adminPermissions.includes('VIEW_ONLY'),
    },
  ];

  const visibleTabs = tabs.filter((tab) => tab.show);
  useEffect(() => {
    const fetchData = async () => {

      try {
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);

        var admin_permissions = user_profile.admin_permissions;
        setAdminPermissions(admin_permissions)
        console.log("%o", user_profile)
      } catch (error) {
        localStorage.removeItem("user_profile");
        console.log("%o", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className={"container"}>
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        variant="scrollable"
        slotProps={{
          indicator: {
            sx: { backgroundColor: "#2348AB" },
          },
        }}
      >
        {visibleTabs.map((tab) => (
          <Tab
            key={tab.label}
            label={tab.label}
            classes={{
              root: styles.tabRoot,
              selected: styles.tabSelected,
            }}
            sx={{ "&.Mui-selected": { color: "#2348AB" } }}
          />
        ))}
      </Tabs>

      <Divider />

      {visibleTabs[tabValue]?.component}
    </div>
  );
};

export default Admin;
